import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ParticipantId } from 'src/app/components/participant/store/participant.model';

@Component({
  selector: 'app-projet-professionnel-evaluation',
  templateUrl: './projet-professionnel-evaluation.component.html',
  styleUrls: ['./projet-professionnel-evaluation.component.scss'],
})
export class ProjetProfessionnelEvaluationComponent implements OnInit {
  @Input() item = new BehaviorSubject<any>(null);
  @Input() participant: ParticipantId | any = null;
  @Input() projetprofessionnel$ = new BehaviorSubject<any>(null);

  constructor() {}

  ngOnInit(): void {}
}
